const getters = {
	origin: () => process.env.VUE_APP_SPACEIN_API_NAV_URL,
	pathPrefix: () => '/navigation-api'
}

import admin from './admin';
import space from './space';
import room from './room';
import pins from './pins';
import guest from './guest';

// spaces used to be called "areas" and rooms used to be called "spaces"
// confusing, right?
// anyway, the back-end is made with the old names
// on the front-end, we're trying to move to the new names
// well, it was originally made with the old names, then we started using the new names without really thinking about it
// and I figure at this point we should commit

const actions = {
	request({dispatch, getters}, data) {
		return dispatch('api/requests/sendAxiosRequest', {
			...data,
			url: getters.origin+getters.pathPrefix+data.url,
		}, {root: true});
	},

	// location navigation apis

	// a "location" is a space or a room, and each has a standard "location" object associated with them
	// it contains info like how many people are in there, and its name, etc

	getLocation({dispatch}, id) {
		return dispatch('request', {
			method: 'get',
			url: `/location/${id}`,
		})
	},
	enterLocation({dispatch}, id) {
		return dispatch('request', {
			method: 'post',
			url: `/location/enter/${id}`,
		})
	},
	joinRoom({dispatch}, id) {
		return dispatch('request', {
			method: 'post',
			url: `/space/join/${id}`,
		})
	},
	leaveRoom({dispatch}) {
		return dispatch('request', {
			method: 'post',
			url: `/space/leave`,
		})
	},
	// this endpoint is special, because it's not really a location
	// this endpoint, unlike the other location endpoints, does *not* return an object with a location object
	// instead it is an object that includes an array of spaces, to be listed on the spaces overview (homepage)
	// it will also register your whereabouts in the back-end as offline, since you will no longer be in a space

	// this is also the v2 of this endpoint. We have two different versions because v1 was just a flat array and v2 is an object
	enterRoot({dispatch}) {
		return dispatch('request', {
			method: 'post',
			url: `/location/v2/enter/root`,
		})
	},
	getRoot({dispatch}) {
		return dispatch('request', {
			method: 'get',
			url: `/location/v2/root`,
		})
	},
	getRootAdmin({dispatch}) {
		return dispatch('request', {
			method: 'get',
			url: `/location/admin-locations`,
		})
	},

	...admin,
	...space,
	...room,
	...pins,
	...guest
};

export default {
	namespaced: true,
	actions,
	getters
};
